var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicVot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 901 329",
    style: {
      enableBackground: "new 0 0 901 329"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106,320.1L-2,4.9h98.3l38.9,135.4c12.3,42.1,19.2,71.3,26.5,106.6h1.4c5.9-32.9,14.2-62.2,27.4-105.6 L230.4,4.9h94.7L214.8,320.1H106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M625.9,162.3c0,89.2-53.5,163.7-161.4,163.7c-106.1,0-157.3-74.1-157.3-163.3C307.2,72.2,363.4-1,469.1-1 C568.3-1,625.9,68.1,625.9,162.3z M402.3,161.4c0,57.6,19.2,97.9,64.9,97.9c48,0,64-42.5,64-96c0-57.6-16.9-97.4-64.9-97.4 C421.5,65.8,402.3,102.8,402.3,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.9,73.5h-90.1V4.9h271.7v68.6h-89.2V320h-92.4V73.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicVot);
export default __webpack_public_path__ + "static/media/graphic_VOT.0ee32947cb7a7299b394a3b2ce406124.svg";
export { ForwardRef as ReactComponent };